<template>
	<div>
		<div class="engage-error">
			<div class="engage-error__icon">
				<font-awesome-icon
					:icon="['fal', 'exclamation-triangle']"
					size="4x"
					style="color: #dc3545;"
				/>
			</div>
			<h3 class="engage-error__title">
				Access to the Engage application is not enabled for your
				account.
			</h3>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			active: 'partners/active',
			isEngageApp: 'partners/isEngageApp',
			clarusAppType: 'partners/clarusAppType',
			isOnlyEngageApp: 'partners/isOnlyEngageApp',
		}),
	},
	name: 'Fallback',

	watch: {
		isOnlyEngageApp: {
			handler(hasAccess) {
				if (!hasAccess) {
					if (!this.isEngageApp && this.clarusAppType) {
						this.$router.push({ name: 'app.calls' })
					} else if (this.isEngageApp && !this.clarusAppType) {
						this.$router.push({ name: 'app.engage' })
					}
				}
			},
			immediate: true,
		},
		active: {
			handler(newPartner, oldPartner) {
				const newPartnerId = newPartner?.id
				const oldPartnerId = oldPartner?.id
				if (
					newPartnerId &&
					newPartnerId !== oldPartnerId &&
					!this.isEngageApp &&
					this.clarusAppType
				) {
					this.$router.push({ name: 'app.calls' })
				} else if (
					newPartnerId &&
					newPartnerId !== oldPartnerId &&
					this.isEngageApp &&
					!this.clarusAppType
				) {
					this.$router.push({ name: 'app.engage' })
				} else if (
					newPartnerId &&
					newPartnerId !== oldPartnerId &&
					this.isOnlyEngageApp
				) {
					this.$router.push({ name: 'app.fallback' })
				}
			},
			immediate: true,
		},
	},
}
</script>
